import { GridRowId, GridRowSelectionModel } from "@mui/x-data-grid-pro";

export const emptyRowSelectionModel = (): GridRowSelectionModel => ({
  type: "include",
  ids: new Set<GridRowId>(),
});

export const getSelectedRowIds = (model: GridRowSelectionModel | undefined): GridRowId[] => (
  model ? Array.from(model.ids) : []
);

export const getSelectedRowCount = (model: GridRowSelectionModel | undefined): number => (
  model?.ids.size ?? 0
);
